"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Button;

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function Button(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MainContainer, {
    type: "button",
    typeButton: props.type,
    onClick: function onClick(e) {
      e.stopPropagation();
      props.onClick && props.onClick(e);
    },
    children: props.children
  });
}